const selectors = {
  dataTabButton: 'data-tab-button',
  dataTabContent: 'data-tab-content',
  dataTabButtonAttr: '[data-tab-button]',
  dataTabContentAttr: '[data-tab-content]',
};

const buttons = document.querySelectorAll(selectors.dataTabButtonAttr);
const tabs = document.querySelectorAll(selectors.dataTabContentAttr);

buttons.forEach((button) => {
  button.addEventListener('click', (e) => {
    const tabNumber = e.target.dataset.tabButton;
    buttons.forEach((item) => {
      item.classList.remove('active');
      if (item.dataset.tabButton === tabNumber) {
        item.classList.add('active');
      }
    });
    tabs.forEach((tab) => {
      // eslint-disable-next-line
      tab.style.display = 'none';
      if (tab.dataset.tabContent === tabNumber) {
        // eslint-disable-next-line
        tab.style.display = 'grid';
      }
    });
  });
});

buttons[0]?.click();
